"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ILTemporaryDrawer = void 0;
var material_1 = require("@mui/material");
var react_1 = __importDefault(require("react"));
var enums_1 = require("../../shared/enums");
var il_icon_common_1 = require("../il-icon/il-icon.common");
var solid_icon_definitions_1 = require("../il-icon/solid-icon-definitions");
function ILTemporaryDrawer(_a) {
    var _b = _a.anchor, anchor = _b === void 0 ? enums_1.AnchorEnum.LEFT : _b, clickableComponent = _a.clickableComponent, onCloseDrawer = _a.onCloseDrawer, _c = _a.showClose, showClose = _c === void 0 ? false : _c, children = _a.children, sx = _a.sx, classes = _a.classes, _d = _a.maxWidth, maxWidth = _d === void 0 ? 'md' : _d, drawerProps = _a.drawerProps;
    var _e = react_1.default.useState(false), open = _e[0], setOpen = _e[1];
    function onClick() {
        setOpen(!open);
    }
    function onClose() {
        setOpen(false);
        onCloseDrawer && onCloseDrawer();
    }
    return (react_1.default.createElement(material_1.Box, { sx: sx, className: 'il-temporary-drawer ' + classes, key: anchor },
        react_1.default.cloneElement(clickableComponent, {
            onClick: onClick,
        }),
        react_1.default.createElement(material_1.Drawer, __assign({ anchor: anchor, open: open, onClose: onClose, sx: {
                position: 'relative',
                '& .MuiDrawer-paper': {
                    width: '100%',
                    maxWidth: [enums_1.AnchorEnum.LEFT, enums_1.AnchorEnum.RIGHT].includes(anchor) ? maxWidth : '100%',
                },
            } }, drawerProps),
            showClose && (react_1.default.createElement(material_1.Box, { sx: {
                    position: 'absolute',
                    pt: '1.5rem',
                    pr: '1.5rem',
                    top: 0,
                    right: 0,
                    cursor: 'pointer',
                }, onClick: onClose, "data-testid": "close-icon" },
                react_1.default.createElement(il_icon_common_1.SolidIcon, { icon: solid_icon_definitions_1.SolidIconDefinitions.X_MARK_ICON }))),
            react_1.default.cloneElement(children, {
                onClose: onClose,
            }))));
}
exports.ILTemporaryDrawer = ILTemporaryDrawer;
